var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { r as registerInstance, h, H as Host, c as createEvent } from './index-6042f3c2.js';
import { V as ViewType, L as LinkSize, T as ThemePalette } from './link.interface-df3534db.js';
import './toast-popup-ae3a1895.js';
import { s as showToast } from './toast-manager-2eb7cc10.js';
var css = ".ispui-fieldset{position:absolute;top:0;right:0;bottom:0;left:0;overflow:hidden;margin:0;-webkit-transition:border-color 0.2s ease;transition:border-color 0.2s ease;pointer-events:none;border:var(--ispui-input__border-width, 1px) solid var(--ispui-input__border-color, #d8d8d8);border-radius:var(--ispui-input__border-radius, 5px)}.ispui-input_invalid .ispui-fieldset{border-color:var(--ispui-input__accent-color, #e54993)}.ispui-fieldset__host{position:absolute;top:0;right:0;bottom:0;left:0;pointer-events:none}.ispui-fieldset__legend{max-width:0.01px;padding:0;-webkit-transition:max-width 0.1s ease;transition:max-width 0.1s ease;opacity:0}.ispui-fieldset__legend_active{max-width:100%;margin-left:0;padding-right:8px;font-size:var(--ispui-input__label-font-size_active, 12px)}.ispui-fieldset_active{border-color:var(--ispui-input__border-color_active, #0279c0)}";
var InputFieldset = /** @class */ (function () {
    function InputFieldset(hostRef) {
        registerInstance(this, hostRef);
    }
    InputFieldset.prototype.render = function () {
        return (h(Host, { class: "ispui-fieldset__host" }, h("fieldset", { "aria-hidden": "true", class: "ispui-fieldset " + (this.isActive ? 'ispui-fieldset_active' : '') }, this.label && this.label.length && (h("legend", { class: "ispui-fieldset__legend " + (!this.isEmpty ? 'ispui-fieldset__legend_active' : '') + " " }, h("span", null, this.label), this.isRequired && '*')))));
    };
    return InputFieldset;
}());
InputFieldset.style = css;
var css$1 = ".ispui-input{position:relative;display:-ms-inline-flexbox;display:inline-flex;width:var(--ispui-input__width, 280px);border-radius:var(--ispui-input__border-radius, 5px);outline:0 none;outline-width:0;line-height:0}.ispui-input__container{position:relative;-ms-flex-positive:1;flex-grow:1;-webkit-box-sizing:border-box;box-sizing:border-box;width:0;max-width:100%}.ispui-input__container_filled{position:static}.ispui-input_disabled{background-color:var(--ispui-input__background-color_disabled, #f4f4f4)}.ispui-input__text_accent{color:var(--ispui-input__accent-color, #e54993)}.ispui-input__label{position:absolute;left:calc(var(--ispui-input__label-left-offset, 10px) + var(--ispui-input__border-width, 1px));display:block;overflow:hidden;max-width:calc(100% - var(--ispui-input__label-left-offset, 10px) - var(--ispui-input__right-padding, 15px));cursor:text;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-transition:all 0.2s ease;transition:all 0.2s ease;white-space:nowrap;text-overflow:ellipsis;pointer-events:none;color:var(--ispui-input__label-color, #b5b9c6);font-size:var(--ispui-input__label-font-size, 14px);line-height:var(--ispui-input__height, 35px)}.ispui-input__label_active{color:var(--ispui-input__active-color, #0279c0)}.ispui-input__label_filled{top:0;left:calc(var(--ispui-input__left-padding, 15px) + var(--ispui-input__border-width, 1px) * 2);max-width:calc(100% - var(--ispui-input__left-padding, 15px) - var(--ispui-input__right-padding, 15px));-webkit-transform:translateY(-50%);transform:translateY(-50%);font-size:var(--ispui-input__label-font-size_active, 12px)}.ispui-input_invalid .ispui-input__label{color:var(--ispui-input__accent-color, #e54993)}.ispui-input__field{-webkit-box-sizing:border-box;box-sizing:border-box;width:100%;padding-right:var(--ispui-input__right-padding, 15px);padding-left:var(--ispui-input__left-padding, 15px);color:var(--ispui-input__text-color, #344a5e);border-color:transparent;border-radius:var(--ispui-input__border-radius, 5px);outline:0 none;background:var(--ispui-input__background-color, transparent);font-family:var(--ispui-input__font-family, \"Ubuntu\"), sans-serif;font-size:var(--ispui-input__font-size, 14px);-webkit-appearance:none;-moz-appearance:none;appearance:none;height:var(--ispui-input__height, 35px);line-height:var(--ispui-input__height, 35px)}.ispui-input__field:disabled{color:var(--ispui-input__text-color_disabled, #9b9b9b);background-color:var(--ispui-input__background-color_disabled, #f4f4f4)}.ispui-input__field[type=date]{padding-right:calc(var(--ispui-input__right-padding, 15px) - 10px);line-height:normal}.ispui-input__field[type=date]::-webkit-calendar-picker-indicator{opacity:0.35}.ispui-input__field::-webkit-input-placeholder{color:var(--ispui-input__label-color, #b5b9c6);font-size:var(--ispui-input__label-font-size, 14px)}.ispui-input__field::-moz-placeholder{color:var(--ispui-input__label-color, #b5b9c6);font-size:var(--ispui-input__label-font-size, 14px)}.ispui-input__field:-ms-input-placeholder{color:var(--ispui-input__label-color, #b5b9c6);font-size:var(--ispui-input__label-font-size, 14px)}.ispui-input__field::-ms-input-placeholder{color:var(--ispui-input__label-color, #b5b9c6);font-size:var(--ispui-input__label-font-size, 14px)}.ispui-input__field::placeholder{color:var(--ispui-input__label-color, #b5b9c6);font-size:var(--ispui-input__label-font-size, 14px)}.ispui-input__prefix{margin-left:var(--ispui-input__left-padding, 15px);-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-animation:fade-in 0.2s ease forwards;animation:fade-in 0.2s ease forwards;opacity:0;color:var(--ispui-input__prefix-color, #9b9b9b);font-family:var(--ispui-input__font-family, \"Ubuntu\"), sans-serif;font-size:var(--ispui-input__font-size, 14px);line-height:var(--ispui-input__height, 35px)}.ispui-input_disabled .ispui-input__prefix{color:var(--ispui-input__prefix-color_disabled, #9b9b9b)}@-webkit-keyframes fade-in{from{opacity:0}to{opacity:1}}@keyframes fade-in{from{opacity:0}to{opacity:1}}.ispui-input__field_has-prefix{padding-left:0}";
var Input = /** @class */ (function () {
    function class_1(hostRef) {
        registerInstance(this, hostRef);
        /** type list for manage input 'isEmpty' state */
        this.ALWAYS_FILLED_INPUT_TYPES = ['month', 'date', 'color', 'datetime-local', 'time', 'week'];
        /** label for input */
        this.label = '';
        /** input value */
        this.value = '';
        /** type for input field */
        this.type = 'text';
        /** input prefix */
        this.inputPrefix = '';
        /** input disabled indicator */
        this.disabled = false;
        /** input required indicator */
        this.required = false;
        /** input invalid indicator */
        this.invalid = false;
        /** enable autofocus */
        this.autofocus = false;
        /** input placeholder */
        this.placeholder = '';
        /** input active state */
        this.isActive = false;
        /** textarea value empty state */
        this.isEmpty = true;
        this.blurEvent = createEvent(this, "customBlur", 7);
        this.changeEvent = createEvent(this, "customChange", 7);
    }
    /**
     * Validate value prop
     * @param val - field value
     */
    class_1.prototype.handleFieldState = function (val) {
        if (this.isInputFilled(val, this.type) || this.isActive) {
            this.isEmpty = false;
        }
        else {
            this.isEmpty = true;
        }
    };
    /**
     * Validate placeholder value
     * @param placeholder - placeholder value
     */
    class_1.prototype.validatePlaceholderProp = function (placeholder) {
        if (!placeholder) {
            this.placeholder = '';
        }
        else {
            this.placeholder = placeholder;
        }
    };
    /**
     * Method for focus native element
     */
    class_1.prototype.focusNative = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                this.nativeInput.focus();
                return [2 /*return*/];
            });
        });
    };
    /**
     * LIFECYCLE
     * set active state on component init
     */
    class_1.prototype.componentWillLoad = function () {
        if (!this.value) {
            this.value = '';
        }
        if (this.isInputFilled(this.value, this.type)) {
            this.isEmpty = false;
        }
    };
    /**
     * Set active state on component focus
     */
    class_1.prototype.handleFocus = function () {
        this.isActive = true;
        this.isEmpty = false;
    };
    /**
     * Handle component value and emit change event
     * @param event - input event
     */
    class_1.prototype.handleInput = function (event) {
        this.value = event.target.value;
        this.changeEvent.emit({ value: this.value });
    };
    /**
     * Handle component active state on blur
     */
    class_1.prototype.handleBlur = function () {
        if (!this.isInputFilled(this.value, this.type)) {
            this.isEmpty = true;
        }
        this.isActive = false;
        this.blurEvent.emit();
    };
    /**
     *
     * @param type - input type
     */
    class_1.prototype.isInputFilled = function (val, type) {
        return (val && val.length > 0) || this.ALWAYS_FILLED_INPUT_TYPES.includes(type);
    };
    /**
     * Format class list for host component
     */
    class_1.prototype.getClassString = function () {
        var classList = ['ispui-input'];
        this.disabled && classList.push('ispui-input_disabled');
        this.invalid && classList.push('ispui-input_invalid');
        return classList.join(' ');
    };
    class_1.prototype.render = function () {
        var _this = this;
        var _a;
        var canShowPrefix = function () { var _a; return ((_a = _this.inputPrefix) === null || _a === void 0 ? void 0 : _a.length) && !_this.isEmpty; };
        return (h(Host, { class: this.getClassString() }, h("div", { style: { display: canShowPrefix() ? '' : 'none' }, class: "ispui-input__prefix" }, this.inputPrefix), h("div", { class: "ispui-input__container " + (!this.isEmpty ? 'ispui-input__container_filled' : '') }, this.label && (h("label", { class: "ispui-input__label " + (this.isActive ? 'ispui-input__label_active' : '') + " " + (!this.isEmpty ? 'ispui-input__label_filled' : '') }, this.label, this.required && h("span", { class: "ispui-input__text_accent" }, "*"))), h("input", { tabIndex: 0, onInput: function (e) { return _this.handleInput(e); }, onFocus: function () { return _this.handleFocus(); }, onBlur: function () { return _this.handleBlur(); }, type: this.type, class: "ispui-input__field " + (((_a = this.inputPrefix) === null || _a === void 0 ? void 0 : _a.length) ? 'ispui-input__field_has-prefix' : ''), disabled: this.disabled, autocomplete: this.autocomplete, autoFocus: this.autofocus, form: this.form, maxLength: this.maxlength, minLength: this.minlength, name: this.name, id: this.dataid, pattern: this.pattern, readOnly: this.readonly, placeholder: !this.label || !this.label.length || this.isActive ? "" + this.placeholder : '', ref: function (el) { return (_this.nativeInput = el); }, min: this.min, max: this.max, value: this.value })), h("ispui-fieldset", { label: this.label, isActive: this.isActive, isEmpty: this.isEmpty, isRequired: this.required }), h("slot", null)));
    };
    Object.defineProperty(class_1, "watchers", {
        get: function () {
            return {
                "value": ["handleFieldState"],
                "placeholder": ["validatePlaceholderProp"]
            };
        },
        enumerable: false,
        configurable: true
    });
    return class_1;
}());
Input.style = css$1;
var ispuiLinkCss = ".ispui-link{display:var(--ispui-link__display-type, inline-block);cursor:pointer;font-family:var(--ispui-link__font-family, Ubuntu, sans-serif);font-size:14px}.ispui-link_type_default{text-decoration:underline}.ispui-link_type_default-hover{text-decoration:none}.ispui-link_type_default-hover:hover{text-decoration:underline}.ispui-link_type_dropdown{-webkit-text-decoration:var(--ispui-link__type-dropdown_text-decoration, underline);text-decoration:var(--ispui-link__type-dropdown_text-decoration, underline);-webkit-text-decoration-style:var(--ispui-link__type-dropdown_text-decoration-style, dashed);text-decoration-style:var(--ispui-link__type-dropdown_text-decoration-style, dashed)}.ispui-link_type_dropdown-hover{text-decoration:none}.ispui-link_type_dropdown-hover:hover{-webkit-text-decoration:var(--ispui-link__type-dropdown-hover_text-decoration, underline);text-decoration:var(--ispui-link__type-dropdown-hover_text-decoration, underline);-webkit-text-decoration-style:var(--ispui-link__type-dropdown-hover_text-decoration-style, dashed);text-decoration-style:var(--ispui-link__type-dropdown-hover_text-decoration-style, dashed)}.ispui-link_type_modal{position:relative;padding-right:15px}.ispui-link_type_modal::before{content:\"\";position:absolute;top:8px;right:8px;width:5.5px;height:1px}.ispui-link_type_modal::after{content:\"\";position:absolute;top:6px;right:6px;width:0;height:0;-webkit-transform:scaleX(2) translateY(0.5px) rotate(-45deg);transform:scaleX(2) translateY(0.5px) rotate(-45deg);border-width:2px;border-style:solid}.ispui-link_type_modal-underline{position:relative;padding-right:15px;text-decoration:underline}.ispui-link_type_modal-underline::before{content:\"\";position:absolute;top:8px;right:8px;width:5.5px;height:1px}.ispui-link_type_modal-underline::after{content:\"\";position:absolute;top:6px;right:6px;width:0;height:0;-webkit-transform:scaleX(2) translateY(0.5px) rotate(-45deg);transform:scaleX(2) translateY(0.5px) rotate(-45deg);border-width:2px;border-style:solid}.ispui-link_type_modal-hover{position:relative;padding-right:15px;text-decoration:none}.ispui-link_type_modal-hover::before{content:\"\";position:absolute;top:8px;right:8px;width:5.5px;height:1px}.ispui-link_type_modal-hover::after{content:\"\";position:absolute;top:6px;right:6px;width:0;height:0;-webkit-transform:scaleX(2) translateY(0.5px) rotate(-45deg);transform:scaleX(2) translateY(0.5px) rotate(-45deg);border-width:2px;border-style:solid}.ispui-link_type_modal-hover:hover{text-decoration:underline}.ispui-link_type_disabled{cursor:not-allowed;text-decoration:none;pointer-events:none;color:var(--ispui-link__color_inactive, #d9d9d9)}.ispui-link_type_disabled::before{background-color:var(--ispui-link__color_inactive, #d9d9d9)}.ispui-link_type_disabled::after{border-top-color:transparent;border-left-color:transparent}.ispui-link_color_primary{color:var(--ispui-link__color_regular, #0279c0)}.ispui-link_color_primary::before{background-color:var(--ispui-link__color_regular, #0279c0)}.ispui-link_color_primary::after{border-color:var(--ispui-link__color_regular, #0279c0);border-top-color:transparent;border-left-color:transparent}.ispui-link_color_primary:hover{color:var(--ispui-link__color_hover, #0991e2)}.ispui-link_color_primary:hover::before{border-color:var(--ispui-link__color_hover, #0991e2)}.ispui-link_color_primary:hover::after{border-color:var(--ispui-link__color_hover, #0991e2);border-top-color:transparent;border-left-color:transparent}.ispui-link_color_primary:active{color:var(--ispui-link__color_active, #035b90)}.ispui-link_color_primary:active::before{border-color:var(--ispui-link__color_active, #035b90)}.ispui-link_color_primary:active::after{border-color:var(--ispui-link__color_active, #035b90);border-top-color:transparent;border-left-color:transparent}.ispui-link_color_primary:disabled::before{border-color:var(--ispui-link__color_inactive, #d9d9d9)}.ispui-link_color_primary:disabled::after{border-color:var(--ispui-link__color_inactive, #d9d9d9);border-top-color:transparent;border-left-color:transparent}.ispui-link_color_additional{color:var(--ispui-link__color-additional, #9b9b9b)}.ispui-link_color_additional::before{background-color:var(--ispui-color__additional-text, #9b9b9b)}.ispui-link_color_additional::after{border-color:var(--ispui-color__additional-text, #9b9b9b);border-top-color:transparent;border-left-color:transparent}.ispui-link_color_inverse{color:var(--ispui-link__color_inverse, #f8e71c)}.ispui-link_color_inverse::before{background-color:var(link__color_inverse, #f8e71c)}.ispui-link_color_inverse::after{border-color:var(--ispui-link__color_inverse, #f8e71c);border-top-color:transparent;border-left-color:transparent}.ispui-link_color_inverse:hover{color:var(--ispui-link__color_inverse_hover, #fff680)}.ispui-link_color_inverse:hover::before{border-color:var(--ispui-link__color_inverse_hover, #fff680)}.ispui-link_color_inverse:hover::after{border-color:var(--ispui-link__color_inverse_hover, #fff680);border-top-color:transparent;border-left-color:transparent}.ispui-link_color_inverse:active{color:var(--ispui-link__color_inverse_active, #ffd100)}.ispui-link_color_inverse:active::before{border-color:var(--ispui-link__color_inverse_active, #ffd100)}.ispui-link_color_inverse:active::after{border-color:var(--ispui-link__color_inverse_active, #ffd100);border-top-color:transparent;border-left-color:transparent}.ispui-link_color_success{color:var(--ispui-link__color_success, #30ba9a)}.ispui-link_color_success::before{background-color:var(link__color_success, #30ba9a)}.ispui-link_color_success::after{border-color:var(--ispui-link__color_success, #30ba9a);border-top-color:transparent;border-left-color:transparent}.ispui-link_color_success:hover{color:var(--ispui-link__color_success_hover, #55e0c0)}.ispui-link_color_success:hover::before{border-color:var(--ispui-link__color_success_hover, #55e0c0)}.ispui-link_color_success:hover::after{border-color:var(--ispui-link__color_success_hover, #55e0c0);border-top-color:transparent;border-left-color:transparent}.ispui-link_color_success:active{color:var(--ispui-link__color_success_active, #1c9b7d)}.ispui-link_color_success:active::before{border-color:var(--ispui-link__color_success_active, #1c9b7d)}.ispui-link_color_success:active::after{border-color:var(--ispui-link__color_success_active, #1c9b7d);border-top-color:transparent;border-left-color:transparent}.ispui-link_color_fail{color:var(--ispui-link__color_fail, #e44592)}.ispui-link_color_fail::before{background-color:var(--ispui-link__color_fail, #e44592)}.ispui-link_color_fail::after{border-color:var(--ispui-link__color_fail, #e44592);border-top-color:transparent;border-left-color:transparent}.ispui-link_color_fail:hover{color:var(--ispui-link__color_fail_hover, #fc8cc2)}.ispui-link_color_fail:hover::before{border-color:var(--ispui-link__color_fail_hover, #fc8cc2)}.ispui-link_color_fail:hover::after{border-color:var(--ispui-link__color_fail_hover, #fc8cc2);border-top-color:transparent;border-left-color:transparent}.ispui-link_color_fail:active{color:var(--ispui-link__color_fail_active, #c52e77)}.ispui-link_color_fail:active::before{border-color:var(--ispui-link__color_fail_active, #c52e77)}.ispui-link_color_fail:active::after{border-color:var(--ispui-link__color_fail_active, #c52e77);border-top-color:transparent;border-left-color:transparent}.ispui-link_size_micro{font-size:var(--ispui-font-size-micro, 8px)}.ispui-link_size_small{font-size:var(--ispui-font-size-small, 12px)}.ispui-link_size_regular{font-size:var(--ispui-font-size-regular, 14px)}.ispui-link_size_main{font-size:var(--ispui-font-size-main, 16px)}.ispui-link_size_medium{font-size:var(--ispui-font-size-medium, 18px)}.ispui-link_size_big{font-size:var(--ispui-font-size-big, 25px)}.ispui-link_size_bigger{font-size:var(--ispui-font-size-bigger, 48px)}.ispui-link_ellipsis{display:block;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}";
var Link = /** @class */ (function () {
    function Link(hostRef) {
        registerInstance(this, hostRef);
        /** Disabled state for Link (default false) */
        this.disabled = false;
        /** Indicator for folding text into an ellipsis
         * when the size of an external container is exceeded */
        this.ellipsis = false;
        this.linkType = ViewType.default;
        this.linkSize = LinkSize.regular;
        this.linkColor = ThemePalette.primary;
    }
    Link.prototype.validateType = function (newLinkType) {
        if (!newLinkType) {
            return;
        }
        if (Object.values(ViewType).includes(newLinkType)) {
            this.linkType = newLinkType;
        }
        else {
            console.warn("Type " + newLinkType + " is not valid!");
        }
    };
    Link.prototype.validateLinkSize = function (newLinkSize) {
        if (!newLinkSize) {
            return;
        }
        if (Object.values(LinkSize).includes(newLinkSize)) {
            this.linkSize = newLinkSize;
        }
        else {
            console.warn("Size " + newLinkSize + " is not valid!");
        }
    };
    Link.prototype.validateLinkColor = function (newLinkColor) {
        if (!newLinkColor) {
            return;
        }
        if (Object.values(ThemePalette).includes(newLinkColor)) {
            this.linkColor = newLinkColor;
        }
        else {
            console.warn("Color " + newLinkColor + " is not valid!");
        }
    };
    Link.prototype.componentWillLoad = function () {
        this.validateLinkColor(this.color);
        this.validateLinkSize(this.size);
        this.validateType(this.type);
    };
    /** Get all classes for current link from attributes */
    Link.prototype._getClasses = function () {
        var currentClasses = {};
        currentClasses["ispui-link_type_" + this.linkType] = true;
        currentClasses["ispui-link_size_" + this.linkSize] = true;
        currentClasses["ispui-link_color_" + this.linkColor] = !this.disabled;
        currentClasses['ispui-link_ellipsis'] = this.ellipsis;
        currentClasses['ispui-link_type_disabled'] = this.disabled;
        return Object.keys(currentClasses)
            .filter(function (key) { return currentClasses[key]; })
            .join(' ');
    };
    Link.prototype.render = function () {
        var classes = this._getClasses();
        return (h(Host, { style: { pointerEvents: this.disabled ? 'none' : 'auto' } }, h("a", { class: "ispui-link " + classes, href: this.disabled ? '' : this.href, target: this.target, rel: "noopener noreferrer" }, h("slot", null))));
    };
    Object.defineProperty(Link, "watchers", {
        get: function () {
            return {
                "type": ["validateType"],
                "size": ["validateLinkSize"],
                "color": ["validateLinkColor"]
            };
        },
        enumerable: false,
        configurable: true
    });
    return Link;
}());
Link.style = ispuiLinkCss;
/** перечисления типов символов */
var CharTypes;
(function (CharTypes) {
    CharTypes["NUMBER"] = "NUMBER";
    CharTypes["ALPHA"] = "ALPHA";
    CharTypes["UPPER"] = "UPPER";
    CharTypes["LOWER"] = "LOWER";
    CharTypes["SPECIAL"] = "SPECIAL";
    CharTypes["OTHER"] = "OTHER";
})(CharTypes || (CharTypes = {}));
/**
 * Класс генерации пароля
 * Генерирует пароль заданной длины из заданных символов
 */
var PasswordGenerator = /** @class */ (function () {
    function PasswordGenerator(length, options) {
        if (length === void 0) { length = 8; }
        if (options === void 0) { options = {
            useNumber: true,
            useUpperCase: true,
            useLowerCase: true,
            useSpecial: false,
        }; }
        /** длина пароля */
        this._length = 8;
        /** символы цифр */
        this._numberChars = '1234567890';
        /** символы букв в нижнем регистре */
        this._lowerCaseAlphaChars = 'abcdefghijklmnopqrstuvwxyz';
        /** символы букв в верхнем регистре */
        this._upperCaseAlphaChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
        /** спец символы */
        this._specialChars = '!@#$%^&*?_~';
        /** строка с символоми используемых при генерации */
        this._chars = '';
        /** схема генерируемого пароля по типам символов */
        this._pullTypes = [];
        this._setPasswordOptions(length, options);
    }
    /**
     * Задать настройки генерации пароля
     * @param length - длина генерируемого пароля
     * @param options - объект настроек
     */
    PasswordGenerator.prototype._setPasswordOptions = function (length, options) {
        this._length = length;
        if (options.useNumber) {
            this._chars += this._numberChars;
        }
        if (options.useLowerCase) {
            this._chars += this._lowerCaseAlphaChars;
        }
        if (options.useUpperCase) {
            this._chars += this._upperCaseAlphaChars;
        }
        if (options.useSpecial) {
            this._chars += this._specialChars;
        }
        if (options.customChars) {
            this._chars += options.customChars;
        }
        this._charsByType = {
            NUMBER: this._getChar(new RegExp(/\d/g)),
            UPPER: this._getChar(new RegExp(/[A-Z]/g)),
            LOWER: this._getChar(new RegExp(/[a-z]/g)),
            ALPHA: this._getChar(new RegExp(/([A-Z][a-z])/g)),
            SPECIAL: this._getChar(new RegExp(/[!,@,#,$,%,^,&,*,?,_,~]/g)),
            OTHER: this._getChar(new RegExp(/[^A-Z^a-z^0-9,!,@,#,$,%,^,&,*,?,_,~]/)),
        };
        this._setPullTypes();
    };
    /**
     * Заполнить массив схемы пароля по типам символов в каждой строке
     */
    PasswordGenerator.prototype._setPullTypes = function () {
        if (this._charsByType.LOWER) {
            this._pullTypes.push(CharTypes.LOWER);
        }
        if (this._charsByType.UPPER) {
            this._pullTypes.push(CharTypes.UPPER);
        }
        if (this._charsByType.NUMBER) {
            this._pullTypes.push(CharTypes.NUMBER);
        }
        if (this._charsByType.SPECIAL) {
            this._pullTypes.push(CharTypes.SPECIAL);
        }
        if (this._charsByType.OTHER) {
            this._pullTypes.push(CharTypes.OTHER);
        }
        var pullTypesLength = this._setPullTypes.length;
        for (var i = pullTypesLength, n = 0; i < this._length; i++) {
            if (n === pullTypesLength) {
                n = 0;
            }
            this._pullTypes.push(this._pullTypes[n]);
            n++;
        }
    };
    /**
     * Получить символы по regExp выражению
     * @param regExp - регулярное выражение
     */
    PasswordGenerator.prototype._getChar = function (regExp) {
        var matches = this._chars.match(regExp);
        return matches ? matches.join('') : '';
    };
    /**
     * Сгенерировать пароль
     * @param lenth - длина генерируемого пароля
     */
    PasswordGenerator.prototype.generate = function (length) {
        var pwd = '';
        length = length || this._length;
        var alphaCase = this.alphaCase || CharTypes.LOWER;
        for (var i = 0; i < length; i++) {
            var pullIndex = i % 10;
            var charType = this._pullTypes[pullIndex];
            if (charType === CharTypes.ALPHA) {
                if (this._charsByType.LOWER && this._charsByType.UPPER) {
                    alphaCase = alphaCase === CharTypes.LOWER ? CharTypes.UPPER : CharTypes.LOWER;
                    charType = alphaCase;
                }
            }
            var charString = this._charsByType[charType];
            pwd += charString.substr(Math.floor(Math.random() * charString.length), 1);
        }
        this.alphaCase = alphaCase;
        return pwd;
    };
    return PasswordGenerator;
}());
function clipboardCopy(text) {
    // Use the Async Clipboard API when available. Requires a secure browsing
    // context (i.e. HTTPS)
    if (navigator.clipboard) {
        return navigator.clipboard.writeText(text).catch(function (err) {
            throw err !== undefined ? err : new DOMException('The request is not allowed', 'NotAllowedError');
        });
    }
    // ...Otherwise, use document.execCommand() fallback
    // Put the text to copy into a <span>
    var span = document.createElement('span');
    span.textContent = text;
    // Preserve consecutive spaces and newlines
    span.style.whiteSpace = 'pre';
    // Add the <span> to the page
    document.body.appendChild(span);
    // Make a selection object representing the range of text selected by the user
    var selection = window.getSelection();
    var range = window.document.createRange();
    selection === null || selection === void 0 ? void 0 : selection.removeAllRanges();
    range.selectNode(span);
    selection === null || selection === void 0 ? void 0 : selection.addRange(range);
    // Copy text to the clipboard
    var success = false;
    try {
        success = window.document.execCommand('copy');
    }
    catch (err) {
        console.error('error', err);
    }
    // Cleanup
    selection === null || selection === void 0 ? void 0 : selection.removeAllRanges();
    window.document.body.removeChild(span);
    return success ? Promise.resolve() : Promise.reject(new DOMException('The request is not allowed', 'NotAllowedError'));
}
/* eslint-disable react/no-unknown-property */
var HiddenIcon = function () { return (h("svg", { fill: "none", width: "18", height: "18", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" }, h("g", { fill: "var(--pass-icon-color)" }, h("path", { d: "m20.078 9.5434s-3.3898 5.8333-9.8305 5.8333c-6.4406 0-10.169-5.8333-10.169-5.8333v-0.3775s5.0728 4.1275 10.169 4.1275c5.1859 0 9.8305-4.1284 9.8305-4.1284v0.37833z" }), h("path", { d: "m19.831 7.2525c0-0.1075-0.0445-0.20667-0.1294-0.27167-0.6759-0.51916-3.9885-2.8142-9.7011-2.8142-5.705 0-9.1495 2.2892-9.8619 2.8117-0.090166 0.06584-0.13833 0.17-0.13833 0.2825 0 0.28917 0.31592 0.47584 0.57217 0.34084 1.4365-0.75334 5.3712-2.6017 9.428-2.6017 4.0999 0 7.8614 1.8233 9.2571 2.5867 0.2534 0.13833 0.5734-0.04584 0.5734-0.33417z" })), h("g", { stroke: "var(--pass-icon-color)", "stroke-linecap": "round" }, h("path", { d: "m2.4461 12.244-1.2044 1.8067" }), h("path", { d: "m5.1342 13.838-0.63125 2.525" }), h("path", { d: "m9.4141 14.583v3.3333" }), h("path", { d: "m13.669 14.47 0.6313 2.525" }), h("path", { d: "m17.217 12.074 1.6951 1.975" })))); };
/* eslint-disable react/no-unknown-property */
var EyeIcon = function () { return (h("svg", { width: "18", height: "18", viewBox: "0 0 20 20", fill: "var(--pass-icon-color)", xmlns: "http://www.w3.org/2000/svg" }, h("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M10.1698 16.6665C16.6101 16.6665 20 11.2498 20 11.2498C20 11.2498 16.2703 5.83313 10.1698 5.83313C4.06759 5.83313 0 11.2498 0 11.2498C0 11.2498 3.72962 16.6665 10.1698 16.6665ZM10 15.8331C12.641 15.8331 14.7826 13.7807 14.7826 11.2498C14.7826 8.71887 12.641 6.66646 10 6.66646C7.35903 6.66646 5.21739 8.71887 5.21739 11.2498C5.21739 13.7807 7.35903 15.8331 10 15.8331Z" }), h("path", { d: "M10 14.1665C11.6809 14.1665 13.0435 12.8606 13.0435 11.2498C13.0435 9.63897 11.6809 8.33313 10 8.33313C8.31915 8.33313 6.95654 9.63897 6.95654 11.2498C6.95654 12.8606 8.31915 14.1665 10 14.1665Z" }), h("path", { d: "M19.8652 6.41237C19.8652 6.30928 19.8216 6.21293 19.7376 6.14852C19.065 5.63272 15.7458 3.33337 10.0177 3.33337C4.29783 3.33337 0.846383 5.62594 0.136739 6.14622C0.0472609 6.21182 0 6.31256 0 6.42052C0 6.70969 0.332904 6.89407 0.597844 6.75569C2.05675 5.99373 5.97663 4.16648 10.0177 4.16648C14.1006 4.16648 17.8485 5.96818 19.266 6.7395C19.5277 6.88187 19.8652 6.7007 19.8652 6.41237Z" }))); };
var css$2 = ".ispui-password{--pass-icon-color:var(--ispui-password-icon-color, #979797);display:inline-block}.ispui-password__eye-button{-ms-flex-order:1;order:1;margin-top:2px;margin-right:10px;padding:0;cursor:pointer;border:none;background-color:transparent}.ispui-password__eye-button:hover,.ispui-password__eye-button:focus{opacity:0.8}.ispui-password__side-button{margin-left:var(--ispui-password-side-button-offset, 10px);-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}";
var Password = /** @class */ (function () {
    function class_2(hostRef) {
        registerInstance(this, hostRef);
        /** input value */
        this.value = '';
        /** flag for eye icon visibility */
        this.eye = false;
        /** flag for generate button visibility */
        this.generate = false;
        /** flag for input disable state */
        this.disabled = false;
        /** input required indicator */
        this.required = false;
        /** input invalid indicator */
        this.invalid = false;
        /** input autocomplete flag */
        this.generateLabel = 'Генерировать';
        /** flag for input readonly state */
        this.readonly = false;
        /** flag for copy button visibility */
        this.copy = false;
        /** label for copy button */
        this.copyLabel = 'Копировать';
        /** message for copy success action */
        this.copySuccessMessage = 'Скопировано!';
        /** flag for autogenerate password */
        this.isGeneratePassword = false;
        /** length for autogenerated password */
        this.passwordGenLength = 8;
        /** password field type */
        this.type = 'password';
        this.passwordGenerated = createEvent(this, "passwordGenerated", 7);
    }
    /**
     * Focus native element
     */
    class_2.prototype.focusNative = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                this.inputElement.focusNative();
                return [2 /*return*/];
            });
        });
    };
    /**
     * Generate password value
     * @param passwordLength - password length
     */
    class_2.prototype.generatePassword = function (passwordLength) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                this.value = this._genPasswd.generate(passwordLength);
                this.passwordGenerated.emit({ value: this.value });
                return [2 /*return*/];
            });
        });
    };
    /**
     * Password animation generation
     * @param passwordLength - number of characters to start generation
     */
    class_2.prototype.animatePasswordGeneration = function (passwordLength) {
        if (passwordLength === void 0) { passwordLength = 0; }
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_b) {
                this.type = 'text';
                window.setTimeout(function () {
                    _this.generatePassword(passwordLength);
                    if (passwordLength < _this.passwordGenLength) {
                        _this.animatePasswordGeneration(passwordLength + 1);
                    }
                }, 35);
                return [2 /*return*/];
            });
        });
    };
    /**
     * LIFECYCLE
     */
    class_2.prototype.componentWillLoad = function () {
        this._genPasswd = new PasswordGenerator(this.passwordGenLength);
        if (this.isGeneratePassword) {
            this.generatePassword(this.passwordGenLength);
        }
    };
    /**
     * Toggle password field type
     */
    class_2.prototype.toggleValueVisibility = function () {
        this.type = this.type === 'password' ? 'text' : 'password';
    };
    /**
     * Form password class list
     */
    class_2.prototype.getClassString = function () {
        var classList = ['ispui-password'];
        return classList.join(' ');
    };
    /**
     * Copy current password value to clipboard
     * @param button - HTMLElement anchor for showing copy success message
     */
    class_2.prototype.handleCopyAction = function (button) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_b) {
                clipboardCopy(this.value).then(function () {
                    showToast({
                        toastContent: _this.copySuccessMessage,
                        anchorElement: button,
                    });
                });
                return [2 /*return*/];
            });
        });
    };
    /**
     * Sync input value && password value
     * @param e - input field event
     */
    class_2.prototype.handleInput = function (e) {
        this.value = e.target.value;
    };
    class_2.prototype.render = function () {
        var _this = this;
        return (h(Host, { class: this.getClassString() }, h("ispui-input", { type: this.type, label: this.label, value: this.value, disabled: this.disabled, required: this.required, invalid: this.invalid, readonly: this.readonly, name: this.name, autocomplete: this.autocomplete, onInput: function (e) { return _this.handleInput(e); }, maxlength: this.maxlength, minlength: this.minlength, dataid: this.dataid, ref: function (el) { return (_this.inputElement = el); } }, this.eye && (h("button", { type: "button", tabIndex: 0, class: "ispui-password__eye-button", onClick: function () { return _this.toggleValueVisibility(); } }, this.type === 'password' ? h(HiddenIcon, null) : h(EyeIcon, null))), h("slot", { name: "input-content" })), this.generate && (h("ispui-link", { type: ViewType.default_hover, class: "ispui-password__side-button", onClick: function () { return _this.animatePasswordGeneration(); } }, this.generateLabel)), this.copy && (h("ispui-link", { type: ViewType.default_hover, class: "ispui-password__side-button", onClick: function (e) { return _this.handleCopyAction(e.target); } }, this.copyLabel))));
    };
    return class_2;
}());
Password.style = css$2;
var css$3 = ".ispui-input{position:relative;display:-ms-inline-flexbox;display:inline-flex;width:var(--ispui-input__width, 280px);border-radius:var(--ispui-input__border-radius, 5px);outline:0 none;outline-width:0;line-height:0}.ispui-input__container{position:relative;-ms-flex-positive:1;flex-grow:1;-webkit-box-sizing:border-box;box-sizing:border-box;width:0;max-width:100%}.ispui-input__container_filled{position:static}.ispui-input_disabled{background-color:var(--ispui-input__background-color_disabled, #f4f4f4)}.ispui-input__text_accent{color:var(--ispui-input__accent-color, #e54993)}.ispui-input__label{position:absolute;left:calc(var(--ispui-input__label-left-offset, 10px) + var(--ispui-input__border-width, 1px));display:block;overflow:hidden;max-width:calc(100% - var(--ispui-input__label-left-offset, 10px) - var(--ispui-input__right-padding, 15px));cursor:text;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-transition:all 0.2s ease;transition:all 0.2s ease;white-space:nowrap;text-overflow:ellipsis;pointer-events:none;color:var(--ispui-input__label-color, #b5b9c6);font-size:var(--ispui-input__label-font-size, 14px);line-height:var(--ispui-input__height, 35px)}.ispui-input__label_active{color:var(--ispui-input__active-color, #0279c0)}.ispui-input__label_filled{top:0;left:calc(var(--ispui-input__left-padding, 15px) + var(--ispui-input__border-width, 1px) * 2);max-width:calc(100% - var(--ispui-input__left-padding, 15px) - var(--ispui-input__right-padding, 15px));-webkit-transform:translateY(-50%);transform:translateY(-50%);font-size:var(--ispui-input__label-font-size_active, 12px)}.ispui-input_invalid .ispui-input__label{color:var(--ispui-input__accent-color, #e54993)}.ispui-textarea__field{height:var(--ispui-textarea__height, initial);margin-top:5px;padding-top:5px;padding-bottom:10px;line-height:18px;scrollbar-color:var(--ispui-scrollbar-thumb-color, #344a5e) var(--ispui-scrollbar-background-color, #ececec);scrollbar-width:thin;-webkit-box-sizing:border-box;box-sizing:border-box;width:100%;padding-right:var(--ispui-input__right-padding, 15px);padding-left:var(--ispui-input__left-padding, 15px);color:var(--ispui-input__text-color, #344a5e);border-color:transparent;border-radius:var(--ispui-input__border-radius, 5px);outline:0 none;background:var(--ispui-input__background-color, transparent);font-family:var(--ispui-input__font-family, \"Ubuntu\"), sans-serif;font-size:var(--ispui-input__font-size, 14px);-webkit-appearance:none;-moz-appearance:none;appearance:none}.ispui-textarea__field::-webkit-scrollbar,.ispui-textarea__field::-webkit-scrollbar-track,.ispui-textarea__field::-webkit-scrollbar-thumb{width:var(--ispui-scrollbar-width, 7px);border-radius:var(--ispui-scrollbar-border-radius, 10px)}.ispui-textarea__field::-webkit-scrollbar{background:var(--ispui-scrollbar-background-color, #ececec)}.ispui-textarea__field::-webkit-scrollbar-thumb{background:var(--ispui-scrollbar-thumb-color, #344a5e)}.ispui-textarea__field::-webkit-scrollbar-button{display:none}.ispui-textarea__field:disabled{color:var(--ispui-input__text-color_disabled, #9b9b9b);background-color:var(--ispui-input__background-color_disabled, #f4f4f4)}.ispui-textarea__field::-webkit-input-placeholder{color:var(--ispui-input__label-color, #b5b9c6);font-size:var(--ispui-input__label-font-size, 14px)}.ispui-textarea__field::-moz-placeholder{color:var(--ispui-input__label-color, #b5b9c6);font-size:var(--ispui-input__label-font-size, 14px)}.ispui-textarea__field:-ms-input-placeholder{color:var(--ispui-input__label-color, #b5b9c6);font-size:var(--ispui-input__label-font-size, 14px)}.ispui-textarea__field::-ms-input-placeholder{color:var(--ispui-input__label-color, #b5b9c6);font-size:var(--ispui-input__label-font-size, 14px)}.ispui-textarea__field::placeholder{color:var(--ispui-input__label-color, #b5b9c6);font-size:var(--ispui-input__label-font-size, 14px)}";
var Textarea = /** @class */ (function () {
    function class_3(hostRef) {
        registerInstance(this, hostRef);
        /** textarea value */
        this.value = '';
        /** textarea disabled indicator */
        this.disabled = false;
        /** textarea required indicator */
        this.required = false;
        /** textarea invalid indicator */
        this.invalid = false;
        /** textarea autofocus */
        this.autofocus = false;
        /** textarea placeholder */
        this.placeholder = '';
        /** textarea active state */
        this.isActive = false;
        /** textarea value empty state */
        this.isEmpty = true;
        this.blurEvent = createEvent(this, "customBlur", 7);
        this.changeEvent = createEvent(this, "customChange", 7);
    }
    /**
     * Validate value prop
     * @param val - field value
     */
    class_3.prototype.handleFieldState = function (val) {
        if ((val && val.length) || this.isActive) {
            this.isEmpty = false;
        }
        else {
            this.isEmpty = true;
        }
    };
    /**
     * Validate placeholder value
     * @param placeholder - placeholder value
     */
    class_3.prototype.validatePlaceholderProp = function (placeholder) {
        if (!placeholder) {
            this.placeholder = '';
        }
        else {
            this.placeholder = placeholder;
        }
    };
    /**
     * Method for focus native element
     */
    class_3.prototype.focusNative = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                this.nativeTextarea.focus();
                return [2 /*return*/];
            });
        });
    };
    /**
     * LIFECYCLE
     * set active state on component init
     */
    class_3.prototype.componentWillLoad = function () {
        if (!this.value) {
            this.value = '';
        }
        if (this.value.length > 0) {
            this.isEmpty = false;
        }
    };
    /**
     * Set active state on component focus
     */
    class_3.prototype.handleFocus = function () {
        this.isActive = true;
        this.isEmpty = false;
    };
    /**
     * Handle component value and emit change event
     * @param event - input event
     */
    class_3.prototype.handleInput = function (event) {
        this.value = event.target.value;
        this.changeEvent.emit({ value: this.value });
    };
    /**
     * Handle component active state on blur
     */
    class_3.prototype.handleBlur = function () {
        if (this.value.length === 0) {
            this.isEmpty = true;
        }
        this.isActive = false;
        this.blurEvent.emit();
    };
    /**
     * Format class list for host component
     */
    class_3.prototype.getClassString = function () {
        var classList = ['ispui-input'];
        this.disabled && classList.push('ispui-input_disabled');
        this.invalid && classList.push('ispui-input_invalid');
        return classList.join(' ');
    };
    class_3.prototype.render = function () {
        var _this = this;
        return (h(Host, { class: this.getClassString() }, this.label && (h("label", { class: "ispui-input__label " + (this.isActive ? 'ispui-input__label_active' : '') + " " + (!this.isEmpty ? 'ispui-input__label_filled' : '') }, this.label, this.required && h("span", { class: "ispui-input__text_accent" }, "*"))), h("textarea", { onInput: function (e) { return _this.handleInput(e); }, onFocus: function () { return _this.handleFocus(); }, onBlur: function () { return _this.handleBlur(); }, class: "ispui-textarea__field", disabled: this.disabled, value: this.value, autoFocus: this.autofocus, cols: this.cols, rows: this.rows, form: this.form, maxLength: this.maxlength, minLength: this.minlength, name: this.name, readOnly: this.readonly, wrap: this.wrap, placeholder: !this.label || !this.label.length || this.isActive ? "" + this.placeholder : '', ref: function (el) { return (_this.nativeTextarea = el); } }), h("ispui-fieldset", { label: this.label, isActive: this.isActive, isEmpty: this.isEmpty, isRequired: this.required })));
    };
    Object.defineProperty(class_3, "watchers", {
        get: function () {
            return {
                "value": ["handleFieldState"],
                "placeholder": ["validatePlaceholderProp"]
            };
        },
        enumerable: false,
        configurable: true
    });
    return class_3;
}());
Textarea.style = css$3;
export { InputFieldset as ispui_fieldset, Input as ispui_input, Link as ispui_link, Password as ispui_password, Textarea as ispui_textarea };
